<template>
  <div class="tw-text-center" :data-test="`tc-job-count-${index}`">{{ jobsCount }}</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const TrustedContactJobsCountColumn = graphql(`
  fragment TrustedContactJobsCountColumn on TrustedContact {
    id
    acceptedHiresCount
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TrustedContactJobsCountColumn>
  index: number
}>()
const column = computed(() => useFragment(TrustedContactJobsCountColumn, props.row))
const jobsCount = computed(() => column.value.acceptedHiresCount)
</script>

<style scoped></style>
